import IconButton from '@material-ui/core/IconButton';
import { ActionButton } from './ActionButton';

export function ResponsiveActionButton({ compact, icon, label, title, ...buttonProps }) {
  if (!compact) {
    return (
      <ActionButton startIcon={icon} title={title} {...buttonProps}>
        {label}
      </ActionButton>
    );
  }

  return (
    <ActionButton component={IconButton} title={title || label} aria-label={label} {...buttonProps}>
      {icon}
    </ActionButton>
  );
}
